import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sub_form_item_space" }

import { ref } from "vue";
import { useMessage, NInput, NFormItem, NButton, NResult, NForm } from "naive-ui";
import { login } from "@/backend.api";
import authModel from "@/models/authModel";
import { forgot } from "@/backend.api";
import identityResult from "@/models/identityResult";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const message = useMessage();
const forgotForm = ref(null) as any;
const loginForm = ref(null) as any;
let isLoading = ref(false);
let isFinished = ref(false);

const isLogin = ref(true);
const loginFormValue = ref({
    login: "",
    password: ""
});
const forgotFormValue = ref({
    email: ""
});
const loginFormRules = {
    login: {
        required: true,
        message: "Введите почту",
        trigger: ["blur"],
        type: "email"
    },
    password: {
        required: true,
        message: "Введите пароль",
        trigger: ["blur"]
    }
};
const forgotFormRules = {
    email: {
        required: true,
        message: "Введите почту",
        trigger: ["blur"],
        type: "email"
    }
};

const doLogin = (event: Event) => {
    event.preventDefault();
    const form = (loginForm as any).value;

    form.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            const signInId: string | null = localStorage.getItem("signinid");

            login(form.model.login, form.model.password, signInId)
                .then((response: any) => {
                    const result = new authModel(response.data);
                    if (result.succeeded) {
                        localStorage.setItem("user", JSON.stringify(response.data));
                        if (response.data.signInId) {
                            localStorage.setItem("signinid", response.data.signInId);
                        }

                        window.location.href = result.redirectPage;
                    } else {
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};

const handleSubmitButton = (e: any) => {
    e.preventDefault();
    const form = (forgotForm as any).value;
    form.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            const promise = forgot(form.model.email);
            promise
                .then((response) => {
                    const result = new identityResult(response.data);
                    if (result.succeeded) {
                        isFinished.value = true;
                    } else {
                        result.getDescriptions();
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};

const switchView = () => {
    isLogin.value = !isLogin.value;
    isFinished.value = false;
    forgotFormValue.value.email = "";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLogin.value)
      ? (_openBlock(), _createBlock(_unref(NForm), {
          key: 0,
          ref_key: "loginForm",
          ref: loginForm,
          name: "loginForm",
          method: "post",
          action: "login",
          model: loginFormValue.value,
          rules: loginFormRules,
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (doLogin($event)), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NFormItem), {
              label: "Логин",
              path: "login"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  placeholder: "Почта",
                  "passively-activated": true,
                  clearable: "",
                  value: loginFormValue.value.login,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((loginFormValue.value.login) = $event)),
                  size: "large",
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (doLogin($event)), ["enter"]))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              label: "Пароль",
              path: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  placeholder: "Секретный",
                  "show-password-on": "click",
                  type: "password",
                  clearable: "",
                  value: loginFormValue.value.password,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((loginFormValue.value.password) = $event)),
                  onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (doLogin($event)), ["enter"])),
                  size: "large"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    (isLogin.value)
      ? (_openBlock(), _createBlock(_unref(NButton), {
          key: 1,
          block: "",
          type: "primary",
          loading: _unref(isLoading),
          strong: "",
          size: "large",
          onClick: doLogin
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" Войти ")
          ])),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (isLogin.value)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            style: {"color":"rgb(24, 160, 88)","text-decoration":"none"},
            onClick: switchView
          }, "Забыли пароль?"))
        : _createCommentVNode("", true)
    ]),
    (!isLogin.value)
      ? _withDirectives((_openBlock(), _createBlock(_unref(NForm), {
          key: 2,
          className: "form",
          ref_key: "forgotForm",
          ref: forgotForm,
          model: forgotFormValue.value,
          rules: forgotFormRules,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NFormItem), {
              path: "email",
              label: "Логин"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: forgotFormValue.value.email,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((forgotFormValue.value.email) = $event)),
                  size: "large",
                  placeholder: "Почта"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NButton), {
              size: "large",
              block: "",
              strong: "",
              loading: _unref(isLoading),
              secondary: "",
              type: "success",
              onClick: handleSubmitButton
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Напомнить ")
              ])),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_unref(NButton), {
              class: "sub_form_item_space",
              tag: "a",
              onClick: switchView,
              text: "",
              href: "#",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Назад")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])), [
          [_vShow, !_unref(isFinished)]
        ])
      : _createCommentVNode("", true),
    (!isLogin.value)
      ? _withDirectives((_openBlock(), _createBlock(_unref(NResult), {
          key: 3,
          size: "small",
          status: "success",
          title: "Новый пароль отправлен на почту"
        }, {
          footer: _withCtx(() => [
            _createVNode(_unref(NButton), {
              tag: "a",
              onClick: switchView,
              text: "",
              href: "#",
              type: "primary"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Назад")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_vShow, _unref(isFinished)]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})